import React from "react";
import bg_img from "../../Assets/img/Hiring.jpg";
import manIcon from "../../Assets/img/manicon.png";
import employerIcon from "../../Assets/img/icon man.png";
import { Link } from "react-router-dom";

const ApplySection = () => {
  return (
    <section className="container Apply-padding">
      <div
        className="rounded-3 p-4 bg-dark text-white overflow-hidden"
        style={{
          backgroundImage: `url(${bg_img})`, // ✅ imported background
          backgroundSize: "cover",
          borderRadius: "10px",
          backgroundPosition: "center",
        }}
      >
        <div className="row g-4">
          {/* Candidates Panel */}
          <div className="col-md-6">
            <div className="candidate rounded-3 overflow-hidden shadow-lg image-hover h-100">
              <div className=" h-100 d-flex flex-column justify-content-betwen text-center p-4">
                <div className="justify-content-center">
                  <h2 className="h4 fw-semibold mb-3">For Candidates</h2>
                  <div className="fs-1 mb-3 text-warning">
                    <img
                      src={manIcon} // ✅ imported
                      height="50"
                      width="50"
                      alt="Candidate Icon"
                    />
                  </div>
                  <p className="text-black">
                    Looking for Your Next Opportunity?
                  </p>
                  <p className="text-white">
                    Explore open roles and grow your career with top companies.
                  </p>
                </div>

                <div className="d-flex justify-content-center">
                  <Link
                    to={"/for-candidate-form"}
                    className="btn btn-purple-2 mt-3 d-flex justify-content-center align-items-center gap-2"
                    style={{
                      color: "white",
                      width: "170px",
                      height: "40px",
                      textDecoration: "none",
                      borderRadius:'0px'
                    }}
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Employers Panel */}
          <div className="col-md-6">
            <div className="candidate rounded-3 overflow-hidden shadow-lg image-hover h-100">
              <div className="p-4 h-100 d-flex flex-column justify-content-between text-center">
                <div>
                  <h2 className="h4 fw-semibold mb-3 text-warning">
                    For Employers
                  </h2>
                  <div className="fs-1 mb-3 text-warning">
                    <img
                      src={employerIcon} // ✅ imported
                      height="50"
                      width="50"
                      alt="Employer Icon"
                    />
                  </div>
                  <p className="text-black ">
                    Need Top Talent Fast?
                  </p>
                  <p className="text-white ">
                    Find skilled professionals for your business.
                  </p>
                </div>

                <div className="d-flex justify-content-center">
                  <Link
                    to={"/for-employer-form"}
                    className="btn btn-purple-2 mt-3 d-flex justify-content-center align-items-center gap-2"
                    style={{
                      color: "white",
                      width: "170px",
                      height: "40px",
                      textDecoration: "none",
                      borderRadius:'0px'
                    }}
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplySection;
